export const PAT_NAV_ITEMS = [
  { id: "executive", label: "Executive Overview" },
  { id: "geography", label: "Geography Analytics" },
  { id: "school", label: "School Drilldown" },
  { id: "subject", label: "Subject Analytics" },
  { id: "grade", label: "Grade Analytics" },
  { id: "outcome", label: "Learning Outcomes" },
  { id: "risk", label: "Risk & Intervention" },
];

export const PAT_TAB_ITEMS = PAT_NAV_ITEMS;
